"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgSync = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", d: "M12.567 1.258c-4.4.175-8.255 3-9.749 7.142a.25.25 0 01-.27.163l-1.69-.254a.5.5 0 00-.506.743l2.68 4.7a.5.5 0 00.785.107l3.77-3.746a.5.5 0 00-.279-.85l-1.715-.256a.25.25 0 01-.192-.35 8.259 8.259 0 117.866 11.59 1.25 1.25 0 10.045 2.5h.047a10.751 10.751 0 10-.792-21.487v-.002z" })));
};
exports.default = SvgSync;
//# sourceMappingURL=Sync.js.map